import { supabase } from '../lib/supabase';

function fileExtension(name) {
  const parts = name.toLowerCase().split('.');
  return parts.length > 1 ? parts[parts.length - 1] : '';
}

function mapPublitioUploadResponse(publitioJson, fileName) {
  const fileId = String(publitioJson.id);
  const previewUrl = publitioJson.url_preview ?? publitioJson.url_download ?? publitioJson.url_short ?? null;
  const downloadUrl = publitioJson.url_download ?? publitioJson.url_preview ?? publitioJson.url_short ?? null;

  return {
    publitioFileId: fileId,
    publitioVideoId: fileId,
    fileUrl: downloadUrl,
    previewUrl,
    thumbnailUrl: publitioJson.url_thumbnail ?? null,
    extension: publitioJson.extension ?? fileExtension(fileName) ?? null,
  };
}

/**
 * Request a single-use Publit.io API signature, then upload the video directly from the browser.
 * File bytes never pass through our edge function.
 */
export async function uploadVideoToPublitioDirect(file, { title, tags, description } = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('No autenticado');

  const authRes = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/publitio-upload`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      fileName: file.name,
      mimeType: file.type,
      title: title ?? file.name,
      tags,
      description,
    }),
  });

  const authJson = await authRes.json().catch(() => ({}));
  if (!authRes.ok) {
    throw new Error(authJson.error || 'No se pudo autorizar la subida de video');
  }

  const query = new URLSearchParams(authJson.authQuery);
  const publitioBody = new FormData();
  publitioBody.append('file', file, file.name);
  Object.entries(authJson.formFields ?? {}).forEach(([key, value]) => {
    if (value != null && value !== '') publitioBody.append(key, String(value));
  });

  const uploadUrl = authJson.uploadUrl ?? 'https://api.publit.io/v1/files/create';
  const publitioRes = await fetch(`${uploadUrl}?${query.toString()}`, {
    method: 'POST',
    body: publitioBody,
  });

  const publitioJson = await publitioRes.json().catch(() => ({}));
  if (!publitioRes.ok || !publitioJson.success) {
    const message = publitioJson.message || publitioJson.error || 'Error al subir a Publit.io';
    throw new Error(message);
  }

  return mapPublitioUploadResponse(publitioJson, file.name);
}
